import React from "react";
import "./Css/Gallary.css";

import img1 from "./Images/anaganvadi.jpg";
import img2 from "./Images/angan2.jpg";
import img3 from "./Images/angan3.jpg";
import img4 from "./Images/nga5.jpg";


export default function Gallary() {
  return (
    <section className="school-social-section">
         <h1 className="main-heading">
      गावाच्या प्रगतीचे आणि उपक्रमांचे प्रेरणादायी क्षणचित्र संग्रह
      </h1>
      <p className="sub-heading">
      गावाच्या विकासाची झलक दाखवणारा प्रेरणादायी फोटो संग्रह
      </p>
      <h2 className="school-social-title">शाळा व सामाजिक उपक्रम</h2>

      <div className="school-social-grid">

        {/* Left Big Image */}
        <img src={img1} alt="event" className="school-img big-img" />

        {/* Right Image Grid */}
        <div className="right-grid">

          {/* Row 1 - Two Small Images */}
          <div className="top-small-row">
            <img src={img2} alt="event" className="school-img small-img" />
            <img src={img3} alt="event" className="school-img small-img" />
          </div>

          {/* Middle Wide Image */}
          <div className="middle-wide-row">
            <img src={img4} alt="event" className="school-img wide-img" />
          </div>
        </div>
      </div>

    </section>
  );
}
